/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_NecklaceInputs */

const en_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necklace`)
};

const es_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collar`)
};

const fr_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collier`)
};

const de_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halskette`)
};

const ja_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネックレス`)
};

const zh_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项链`)
};

const ar_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قلادة`)
};

const id_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalung`)
};

const it_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collana`)
};

const ru_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ожерелье`)
};

const pt_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar`)
};

const ko_val_necklace = /** @type {(inputs: Val_NecklaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`목걸이`)
};

/**
* | output |
* | --- |
* | "Necklace" |
*
* @param {Val_NecklaceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_necklace = /** @type {((inputs?: Val_NecklaceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_NecklaceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_necklace(inputs)
	if (locale === "es") return es_val_necklace(inputs)
	if (locale === "fr") return fr_val_necklace(inputs)
	if (locale === "de") return de_val_necklace(inputs)
	if (locale === "ja") return ja_val_necklace(inputs)
	if (locale === "zh") return zh_val_necklace(inputs)
	if (locale === "ar") return ar_val_necklace(inputs)
	if (locale === "id") return id_val_necklace(inputs)
	if (locale === "it") return it_val_necklace(inputs)
	if (locale === "ru") return ru_val_necklace(inputs)
	if (locale === "pt") return pt_val_necklace(inputs)
	return ko_val_necklace(inputs)
});